import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageBackground from '../components/PageBackgroundBeam';
import PageFooter from '../components/PageFooter';
import './PageOrigenInversion.css';

const MEDIO_2025 = [
  { id: 1, label: 'TELEVISI\u00d3N', value: 353510190, color: '#60a5fa' },
  { id: 2, label: 'RADIO',      value: 35869784,  color: '#4ade80' },
  { id: 3, label: 'OUTDOOR',    value: 28517929,  color: '#fbbf24' },
  { id: 4, label: 'PRINT',      value: 16245978,  color: '#f87171' },
];

const MEDIO_2020 = [
  { id: 1, label: 'TELEVISI\u00d3N', value: 218462123, color: '#60a5fa' },
  { id: 2, label: 'RADIO',      value: 32887725,  color: '#4ade80' },
  { id: 3, label: 'OUTDOOR',    value: 5814378,   color: '#fbbf24' },
  { id: 4, label: 'PRINT',      value: 25031635,  color: '#f87171' },
];

const TOTAL_2025 = MEDIO_2025.reduce((s, d) => s + d.value, 0);
const TOTAL_2020 = MEDIO_2020.reduce((s, d) => s + d.value, 0);

const LABEL_SHORT = { 1: 'TV', 2: 'RADIO', 3: 'OOH', 4: 'PRINT' };

function formatNumber(n) {
  return n.toLocaleString('en-US', { maximumFractionDigits: 0 });
}

function PieChart({ data, total, size = 340, year, idPrefix }) {
  const [hovered, setHovered] = useState(null);
  const cx = size / 2;
  const cy = size / 2;
  const radius = size / 2 - 8;
  const innerRadius = radius * 0.55;

  let cumAngle = -Math.PI / 2;
  const slices = data.map((d) => {
    const pct = d.value / total;
    const angle = pct * 2 * Math.PI;
    const startAngle = cumAngle;
    const endAngle = cumAngle + angle;
    cumAngle = endAngle;

    const x1 = cx + radius * Math.cos(startAngle);
    const y1 = cy + radius * Math.sin(startAngle);
    const x2 = cx + radius * Math.cos(endAngle);
    const y2 = cy + radius * Math.sin(endAngle);

    const ix1 = cx + innerRadius * Math.cos(endAngle);
    const iy1 = cy + innerRadius * Math.sin(endAngle);
    const ix2 = cx + innerRadius * Math.cos(startAngle);
    const iy2 = cy + innerRadius * Math.sin(startAngle);

    const largeArc = angle > Math.PI ? 1 : 0;

    const path = [
      `M ${x1} ${y1}`,
      `A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`,
      `L ${ix1} ${iy1}`,
      `A ${innerRadius} ${innerRadius} 0 ${largeArc} 0 ${ix2} ${iy2}`,
      'Z',
    ].join(' ');

    const midAngle = startAngle + angle / 2;
    const labelR = (radius + innerRadius) / 2;
    const lx = cx + labelR * Math.cos(midAngle);
    const ly = cy + labelR * Math.sin(midAngle);

    return { ...d, pct, path, lx, ly };
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="pie-svg">
      <defs>
        {data.map((d) => (
          <filter key={d.id} id={`glow-${idPrefix}-${d.id}`}>
            <feDropShadow dx="0" dy="0" stdDeviation="6" floodColor={d.color} floodOpacity="0.4" />
          </filter>
        ))}
      </defs>

      {slices.map((s) => (
        <path
          key={s.id}
          d={s.path}
          fill={s.color}
          fillOpacity={hovered === s.id ? 1 : 0.85}
          stroke={hovered === s.id ? '#fff' : 'rgba(15,23,42,0.8)'}
          strokeWidth={hovered === s.id ? 2.5 : 2}
          filter={`url(#glow-${idPrefix}-${s.id})`}
          className="pie-slice"
          onMouseEnter={() => setHovered(s.id)}
          onMouseLeave={() => setHovered(null)}
        />
      ))}
      {slices.map((s) => {
        const show = hovered === s.id;
        const labelR = radius + 20;
        const midAngle = Math.atan2(s.ly - cy, s.lx - cx);
        const tx = cx + labelR * Math.cos(midAngle);
        const ty = cy + labelR * Math.sin(midAngle);
        return show ? (
          <g key={`tip-${s.id}`} pointerEvents="none">
            <rect x={tx - 40} y={ty - 12} width="80" height="24" rx="6"
              fill="rgba(15,23,42,0.92)" stroke={s.color} strokeWidth="1" />
            <text x={tx} y={ty + 1} textAnchor="middle" dominantBaseline="middle"
              className="pie-tooltip-text" fill={s.color}>
              {LABEL_SHORT[s.id]} {(s.pct * 100).toFixed(1)}%
            </text>
          </g>
        ) : null;
      })}

      <text x={cx} y={cy - 10} textAnchor="middle" dominantBaseline="middle" className="pie-center-label">
        {year}
      </text>
      <text x={cx} y={cy + 14} textAnchor="middle" dominantBaseline="middle" className="pie-center-value">
        ${formatNumber(total)}
      </text>
    </svg>
  );
}

function PageMixMedioInversion() {
  const navigate = useNavigate();

  return (
    <PageBackground>
      <div className="origen-page">
        <header className="origen-header">
          <button className="btn-back" onClick={() => navigate('/top-10-gobierno')}>
            &#8592; Top 10 Gobierno
          </button>
          <div className="origen-title-block">
            <h1 className="origen-title">Mix de Medios</h1>
            <p className="origen-subtitle">Distribuci&oacute;n por tipo de medio &middot; Honduras 2020 vs 2025 &middot; USD</p>
          </div>
          <button className="btn-next" onClick={() => navigate('/mixmedio-inversion-2')}>
            Siguiente &#8594;
          </button>
          <img src={require('../assets/logo-publisearch.png')} alt="Publisearch" className="header-logo-inline" onClick={() => navigate('/')} style={{ cursor: 'pointer' }} />
        </header>

        <div className="origen-content">
          <div className="origen-chart-area">
            <PieChart data={MEDIO_2020} total={TOTAL_2020} size={300} year={2020} idPrefix="mm20" />
          </div>

          <div className="origen-chart-area">
            <PieChart data={MEDIO_2025} total={TOTAL_2025} size={300} year={2025} idPrefix="mm25" />
          </div>

          <div className="origen-details">
            {MEDIO_2025.map((d) => {
              const pct2025 = (d.value / TOTAL_2025) * 100;
              const d2020 = MEDIO_2020.find((o) => o.id === d.id);
              const pct2020 = d2020 ? (d2020.value / TOTAL_2020) * 100 : 0;
              const diff = pct2025 - pct2020;
              return (
                <div key={d.id} className="origen-card" style={{ borderColor: d.color }}>
                  <div className="origen-card-header">
                    <span className="origen-card-dot" style={{ background: d.color }}></span>
                    <span className="origen-card-label">{d.label}</span>
                    <span className="origen-card-pct" style={{ color: d.color }}>{pct2025.toFixed(2)}%</span>
                  </div>
                  <div className="origen-card-values">
                    <span className="origen-card-value">${formatNumber(d.value)}</span>
                    <span className={`origen-card-diff ${diff >= 0 ? 'diff-up' : 'diff-down'}`}>
                      {diff >= 0 ? '+' : ''}{diff.toFixed(1)}pp vs 2020
                    </span>
                  </div>
                  <div className="origen-card-bar-bg">
                    <div className="origen-card-bar" style={{ width: `${pct2025}%`, background: d.color }}></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <PageFooter />
      </div>
    </PageBackground>
  );
}

export default PageMixMedioInversion;
